import React, {Component} from 'react';
import Moment from 'react-moment';
import {connect} from 'react-redux';
import {formatarReal} from '../../util/numberUtil';
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {excluirCentroCusto, selecionaCentroCusto} from '../../actions/centro-custo';
import alterarExibicaoDetalhamentoCentroCusto from '../../actions/centro-custo/alterarExibicaoDetalhamentoCentroCusto'
import {buscarTiposOcorrenciaCentroCusto} from '../../actions/centro-custo/index';
import moment from 'moment';
import DetalhesCentroCusto from './DetalhesCentroCusto';
import baixarComprovanteTransferencia from '../../actions/repasse-venda/baixarComprovanteTransferencia';

class CentroCusto extends Component {

    exibirIcone() {
        if (this.props.centroCusto.exibirDetalhe) {
            return <i className="material-icons" style={{cursor: 'pointer'}}
                      onClick={() => this.props.alterarExibicaoDetalhamentoCentroCusto(this.props.centroCusto)}>
                &#xE5C7;</i>
        }
        return <i className="material-icons" style={{cursor: 'pointer'}}
                  onClick={() => this.props.alterarExibicaoDetalhamentoCentroCusto(this.props.centroCusto)}>&#xE5C5;</i>
    }

    selecionarCentroCusto() {
        const {centroCusto} = this.props;
        this.props.buscarTiposOcorrenciaCentroCusto();
        const tipo = {value: centroCusto.tipoOcorrencia, label: centroCusto.descTipoOcorrencia}
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoOcorrencia', tipo);

        const tipoEvento = {value: centroCusto.tipoEventoOcorrencia, label: centroCusto.descTipoEventoOcorrencia}
        this.props.changeFieldValue('formularioPainelCentroCusto', 'tipoEventoOcorrencia', tipoEvento);

        this.props.changeFieldValue('formularioPainelCentroCusto', 'ocorrencia', centroCusto.ocorrencia);
        this.props.changeFieldValue('formularioPainelCentroCusto', 'valorTotalGasto', centroCusto.valorTotalGasto);
        this.props.selecionarDataOcorrencia(moment(centroCusto.dataOcorrencia).toDate());
        this.props.selecionaCentroCusto(centroCusto);

        if (this.props.scrollToForm) {
            this.props.scrollToForm();
        }
    }

    baixarComprovante(urlComprovante, nomeComprovante) {
        baixarComprovanteTransferencia(urlComprovante, nomeComprovante).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeComprovante);
            document.body.appendChild(link);

            link.click();

        });
    }

    render() {
        const {centroCusto} = this.props;
        return (
            <div className="geral">
                <div className={`${this.props.centroCusto.selecionado ? 'resumo-laranja' : 'resumo'}`}>
                    <div className="row">
                        <div className="col-md-1 col-lg-1 col-xl-1"
                             onClick={() => this.props.alterarExibicaoDetalhamentoCentroCusto(centroCusto)}
                             style={{cursor: 'pointer'}}>
                            {this.exibirIcone()}
                        </div>
                        <div className="col"><Moment format="DD/MM/YYYY">{centroCusto.dataEntrada}</Moment></div>
                        <div className="col"> {centroCusto.registradoPor} </div>
                         <div className="col"><Moment format="DD/MM/YYYY">{centroCusto.dataOcorrencia}</Moment></div>
                        <div className="col"> {centroCusto.descTipoOcorrencia} </div>
                        <div className="col"> {centroCusto.descTipoEventoOcorrencia} </div>
                        <div className="col"> {formatarReal(centroCusto.valorTotalGasto)} </div>
                        <div className="col">
                            <i className="material-icons m-1"
                               title='Excluir centro de custo'
                               style={{cursor: 'pointer'}}
                               data-toggle="modal"
                               data-target="#modalExcluirCentroCusto"
                               onClick={() => this.props.selecionaCentroCusto(centroCusto)}>
                                delete
                            </i>
                            <i className="material-icons m-1"
                               style={{cursor: 'pointer'}}
                               title='Editar'
                               onClick={() => this.selecionarCentroCusto()}>
                                edit
                            </i>
                            <i
                                className="material-icons m-1"
                                style={{
                                    cursor: centroCusto.urlComprovante ? 'pointer' : 'not-allowed',
                                    color: centroCusto.urlComprovante ? 'inherit' : 'gray',
                                }}
                                onClick={() => {
                                    if (centroCusto.urlComprovante) {
                                        this.baixarComprovante(centroCusto.urlComprovante, centroCusto.nomeComprovante);
                                    }
                                }}
                                title={centroCusto.urlComprovante ? 'Baixar comprovante' : 'Sem comprovante'}
                            >
                                &#xe2c4;
                            </i>
                        </div>

                    </div>
                    <DetalhesCentroCusto centroCusto={this.props.centroCusto}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tiposOcorrenciaCentroCusto: state.centroCusto.tiposCentroCusto || [],
});

const mapDispatchToProps = {
    changeFieldValue,
    alterarExibicaoDetalhamentoCentroCusto,
    excluirCentroCusto,
    buscarTiposOcorrenciaCentroCusto,
    selecionaCentroCusto,
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCentroCusto',
})(CentroCusto));
